export const defaultListWidth = 300;
export const scrollbarWidth = 18; // depends on the OS, at most should be 18px
